import React, { useCallback, useState } from 'react'
import Spacer from 'react-spacer'
import { VStack } from 'react-stacked'
import unreachable from 'ts-unreachable'
import unwrap from 'ts-unwrap'

import formatCurrency from '../../util/formatCurrency'
import { type ChangeFn } from '../../util/useMultiEditProducts'
import { MoneyField, RadioButton } from '../fields'

import { Content } from './MultiEditForm'

function calculatePrice (currentPrice: number, kind: 'decrease' | 'increase' | 'replace', amount: number): number {
  function endPrice (): number {
    switch (kind) {
      case 'decrease':
        return currentPrice - amount
      case 'increase':
        return currentPrice + amount
      case 'replace':
        return amount
      default:
        unreachable(kind)
    }
  }

  return Math.max(endPrice(), 300)
}
interface EditPriceProps {
  onDismiss: () => void
  onNext: (changeFn: ChangeFn) => void
}

const EditPrice: React.FC<EditPriceProps> = ({ onDismiss, onNext }) => {
  const [kind, setKind] = useState<'decrease' | 'increase' | 'replace'>()

  const [amount, setAmount] = useState<number>()

  const handleOnNext = useCallback(() =>
    onNext(properties => {
      const price = calculatePrice(unwrap(properties?.price), unwrap(kind), unwrap(amount))

      return {
        from: formatCurrency(unwrap(properties?.price)),
        to: formatCurrency(price),
        patch: { price }
      }
    }), [amount, kind, onNext])

  return (
    <Content
      disableNext={kind == null || amount == null}
      onDismiss={onDismiss}
      onNext={handleOnNext}
    >
      <VStack gap={12} paddingVertical={12}>
        <RadioButton checked={kind === 'increase'} onPress={() => setKind('increase')} title='Öka med' />
        <RadioButton checked={kind === 'decrease'} onPress={() => setKind('decrease')} title='Minska med' />
        <RadioButton checked={kind === 'replace'} onPress={() => setKind('replace')} title='Ersätt med' />
      </VStack>

      <Spacer height={16} />

      <MoneyField autoFocus label='Belopp' onChange={setAmount} value={amount} />
    </Content>
  )
}

export default EditPrice
